export const EVENT_LISTENERS = {
  DISCONNECT: 'disconnect',
  CONNECT: 'connect',
  ERROR: 'error',
  WALLET_UPDATE: '/wallet',
  PAYMENT_STATUS: '/paymentStatus'
}

export const SOCKET_ROOM_NAME = {
  WALLET: 'private'
}

export const CMS_CATEGORY = {
  SUPPORT_LINKS: 1,
  OTHER_LINKS: 2,
  LANDING_PAGE: 3,
  AFFILIATE_LANDING_PAGE: 4
}

export const cmsReorder = {
  'general-terms': 1,
  'bonus-terms': 2,
  'cookie-policy': 3,
  'privacy-policy': 4,
  affiliates: 5
}

export const CHAT_PROVIDERS = {
  INTERCOM: 'intercom',
  ZENDESK: 'zendesk'
}

// Intercom user_id is `<tenant>_<userId>`. The same prefix is sent to get-user-details so the backend signs
// exactly this id — keep both sides on this one constant.
export const INTERCOM_USER_ID_PREFIX = process.env.REACT_APP_TENANT
export const getIntercomUserId = (userId) => `${INTERCOM_USER_ID_PREFIX}_${userId}`

export const BONUS_STATUS = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  RESERVED: 'RESERVED',
  CANCELLED: 'CANCELLED',
  FORFEIT: 'FORFEITED',
  EXPIRED: 'EXPIRED',
  COMPLETED: 'COMPLETED',
  ZEROED_OUT: 'ZEROED-OUT',
  LAPSED: 'LAPSED'
}

export const BONUS_NOT_CLAIMABLE_STATUS = [
  BONUS_STATUS.FORFEIT,
  BONUS_STATUS.EXPIRED,
  BONUS_STATUS.COMPLETED,
  BONUS_STATUS.ZEROED_OUT,
  BONUS_STATUS.LAPSED
]

export const BONUS_TYPES = {
  MATCH: 'match',
  FREE_SPINS: 'freespins',
  MANUAL: 'manual',
  BALANCE: 'balance',
  SPORTS_FREEBET: 'sportsFreebet'
}

export const SUMSUB_KYC_STATUS = {
  COMPLETED: 'completed',
  REJECTED: 'rejected',
  PENDING: 'pending'
}

export const DEFAULT_INAVTIVITY_THRESHOLD = 60 * 60 * 1000 // 1 hour
export const DEFAULT_REFRESH_THRESHOLD = 20 * 60 * 1000 // 20 mins

export const USER_KYC_REJECTED_CARD_VARIANT = {
  CARD: 'CARD',
  ROUTE: 'ROUTE'
}

export const BUTTON_VARIANT = {
  CONTENT_ONLY: 'content_only',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  TEXT_ONLY: 'text_only',
  BANNER: 'banner',
  OUTLINE: 'outline',
  FORFEIT_BONUS: 'forfeit-bonus',
  SIGNUP: 'signup'
}

export const KYC_STATUS_TO_INT_MAPPING = {
  APPROVED: 1,
  PENDING: 0,
  Rejected: 6,
  REQUESTED: 7,
  RE_REQUESTED: 10,
  COMPLETED: 1,
  INITIATED: 11
}
